export default "__VITE_PUBLIC_ASSET__b2b8e3bc__"